// Microsoft Clarity — custom event helper.
// The head script (public/index.html) defines window.clarity with a queue,
// so calls are safe even before the external tag finishes loading.
// Event NAMES ONLY — never pass emails, names, addresses or any customer
// data through Clarity events or tags.
export function clarityEvent(name) {
  if (typeof window !== "undefined" && typeof window.clarity === "function") {
    window.clarity("event", name);
  }
}
